import { Box, styled } from '@mui/material';

import { CIconContainerStyle } from './Characteristic.types';

export const CharacteristicContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '12px',
}));

export const CIconContainer = styled('div')(
  ({ textColor }: CIconContainerStyle) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    color: textColor,
  }),
);

export const CTextContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));
